import { useLang } from "@/i18n";

const PHOTOS = [
  { src: "/paris-hero.jpg", cap: "gal.c1", tall: true },
  { src: "/fleet-prestige.jpg", cap: "gal.c2" },
  { src: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cap: "gal.c3" },
  { src: "https://images.pexels.com/photos/15535501/pexels-photo-15535501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cap: "gal.c4", tall: true },
  { src: "https://images.pexels.com/photos/28239490/pexels-photo-28239490.jpeg?auto=compress&cs=tinysrgb&w=940", cap: "gal.c5" },
  { src: "/fleet-van.jpg", cap: "gal.c6" },
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <section id="galerie" className="py-24 px-6 border-b border-[#212631]" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-2">{t("gal.kicker")}</span>
            <h2 className="font-disp text-3xl md:text-5xl text-white">{t("gal.title")}</h2>
          </div>
          <p className="text-sm text-[#9ea8b6] max-w-sm">{t("gal.sub")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {PHOTOS.map((p, i) => (
            <div key={i} data-testid={`gallery-photo-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-[#212631] hover:border-[#c9a24d]/60 transition-all duration-300 ${p.tall ? "row-span-2 h-full min-h-[280px] md:min-h-[420px]" : "h-48 md:h-52"}`}>
              <img src={p.src} alt={t(p.cap)} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060709]/80 via-transparent to-transparent"></div>
              <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-widest text-white/90 bg-[#060709]/70 px-2.5 py-1 rounded-md backdrop-blur-sm">
                {t(p.cap)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
